// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendationsCard-cls1_0sW","cls2":"RecommendationsCard-cls2_MQs RecommendationsCard-cls1_0sW","altLook":"RecommendationsCard-altLook_QKL"};